"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.editMenuConceptProducts = exports.setSelectedMenuConceptProduct = exports.updateMenuConceptProducts = exports.setMenuConceptProducts = exports.setProductSelectionEdited = exports.setTablePagination = exports.setIsEdited = exports.setIsLoading = exports.setErrors = exports.setMenuConcepts = exports.setSelectedMenuConcept = exports.initialMenuConceptState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var pages_1 = require("../../../constants/pages");
exports.initialMenuConceptState = {
    selectedMenuConcept: {
        _id: "",
        name: "",
    },
    menuConcepts: [],
    pagination: pages_1.initialPaginationValues,
    errors: {},
    isLoading: false,
    isEdited: false,
    productSelectionEdited: false,
    menuConceptProducts: [],
    selectedMenuConceptProduct: null,
};
var slice = (0, toolkit_1.createSlice)({
    name: "menuConcepts",
    initialState: exports.initialMenuConceptState,
    reducers: {
        setSelectedMenuConcept: function (state, action) {
            state.selectedMenuConcept = action.payload;
        },
        setMenuConcepts: function (state, action) {
            state.menuConcepts = action.payload;
        },
        setTablePagination: function (state, action) {
            state.pagination = action.payload;
        },
        setErrors: function (state, action) {
            state.errors = action.payload;
        },
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setIsEdited: function (state, action) {
            state.isEdited = action.payload;
        },
        setProductSelectionEdited: function (state, action) {
            state.productSelectionEdited = action.payload;
        },
        setMenuConceptProducts: function (state, action) {
            state.menuConceptProducts = action.payload;
        },
        updateMenuConceptProducts: function (state, action) {
            state.menuConceptProducts.push(action.payload);
        },
        setSelectedMenuConceptProduct: function (state, action) {
            state.selectedMenuConceptProduct = action.payload;
        },
        editMenuConceptProducts: function (state, action) {
            state.menuConceptProducts = state.menuConceptProducts.map(function (x) {
                if (x._id === action.payload._id) {
                    return action.payload;
                }
                return x;
            });
        },
    },
});
exports.setSelectedMenuConcept = (_a = slice.actions, _a.setSelectedMenuConcept), exports.setMenuConcepts = _a.setMenuConcepts, exports.setErrors = _a.setErrors, exports.setIsLoading = _a.setIsLoading, exports.setIsEdited = _a.setIsEdited, exports.setTablePagination = _a.setTablePagination, exports.setProductSelectionEdited = _a.setProductSelectionEdited, exports.setMenuConceptProducts = _a.setMenuConceptProducts, exports.updateMenuConceptProducts = _a.updateMenuConceptProducts, exports.setSelectedMenuConceptProduct = _a.setSelectedMenuConceptProduct, exports.editMenuConceptProducts = _a.editMenuConceptProducts;
exports.default = slice.reducer;
